import httpService from '@/utils/httpService'

export const getProfileApi = async () => {
  const response = await httpService.get('/users/profile/')
  return response.data
}

export const getCaseDetailsApi = async (caseId: string) => {
  const response = await httpService.get(`/cases/${caseId}/`)
  return response.data
}

export const getMetadataApi = async () => {
  const response = await httpService.get('/masters/core/meta')
  return response.data
}

export const getCountriesApi = async () => {
  const response = await httpService.get('/masters/countries/')
  return response.data
}

export const getPlansApi = async () => {
  const response = await httpService.get('/subscriptions/plans/')
  return response.data
}
export const clearSession = async (type: string) => {
  return httpService
    .get('/users/session/clear_session/', {
      params: { type },
    })
    .catch((err) => {
      console.error('Clear session API failed:', err)
    })
}

export const getCasesApi = async (params: any) => {
  const response = await httpService.get('/cases/', { params })
  return response.data
}
